export type LogLevel = `debug` | `error` | `info` | `warn`

export const log = (
  data: string | any[],
  level: LogLevel = `debug`,
  env: string = `production`
) => {
  const showDebugMsgs = env !== `production` || window[`debugForms`]
  if (!showDebugMsgs || !(level in console)) return
  console[level](...data)
}
